import { FileText, Upload, X } from "lucide-react";

export default function FileUploader({ nodFile, fileInputRef, onFileChange, onRemoveFile }) {
  return (
    <div className="space-y-2">
      <label className="text-[#F5F5F7] text-sm font-medium block" style={{ fontFamily: 'JetBrains Mono, monospace' }}>
        Notice of Deposition *
      </label>
      <div
        className={`border-2 border-dashed p-6 text-center cursor-pointer transition-colors ${
          nodFile ? "border-[#38b6ff] bg-[#38b6ff]/5" : "border-[#333333] hover:border-[#E8E8E8]/50"
        }`}
        onClick={() => fileInputRef.current?.click()}
      >
        <input
          ref={fileInputRef}
          type="file" accept=".pdf,.doc,.docx" onChange={onFileChange}
          className="hidden" data-testid="hire-form-nod"
        />
        {nodFile ? (
          <div className="flex items-center justify-center gap-3">
            <FileText className="w-6 h-6 text-[#38b6ff]" />
            <span className="text-[#F5F5F7]">{nodFile.name}</span>
            <button type="button" onClick={(e) => { e.stopPropagation(); onRemoveFile(); }} className="p-1 hover:bg-[#333333] rounded">
              <X className="w-4 h-4 text-[#E0E0E0]" />
            </button>
          </div>
        ) : (
          <>
            <Upload className="w-8 h-8 text-[#E0E0E0] mx-auto mb-2" />
            <p className="text-[#E0E0E0] text-sm">Click to upload your Notice of Deposition</p>
            <p className="text-[#E0E0E0]/60 text-xs mt-1">PDF, DOC, or DOCX (max 10MB)</p>
          </>
        )}
      </div>
    </div>
  );
}
